import React, { useState } from 'react';

// Import the SVG icons as React Components
import { ReactComponent as FacebookIcon } from '../assets/facebook.svg';
import { ReactComponent as InstagramIcon } from '../assets/instagram.svg';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    hp: '', // Honeypot
    privacyAccepted: false // NEU: Status für die Checkbox
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    // NEU: Unterscheidung zwischen Text-Input und Checkbox
    const { name, value, type, checked } = e.target;
    
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Validierung: Felder ausgefüllt?
    if (!formData.name || !formData.email || !formData.message) {
      alert('Bitte füllen Sie alle Felder aus.');
      return;
    }

    // 2. Validierung: Datenschutz akzeptiert? (NEU)
    if (!formData.privacyAccepted) {
      alert('Bitte stimmen Sie der Datenschutzerklärung zu, um fortzufahren.');
      return;
    }

    // 3. Validierung: E-Mail Format
    const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
    if (!emailOk) {
      alert('Bitte eine gültige E-Mail-Adresse eingeben.');
      return;
    }

    try {
      setSubmitting(true);
      const res = await fetch('/api/contact_mail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
          hp: formData.hp || ''
          // privacyAccepted müssen wir nicht zwingend an PHP senden, 
          // da die Validierung hier im Frontend bereits stattgefunden hat.
        }),
      });

      let data = null;
      const ct = res.headers.get('Content-Type') || '';
      if (ct.includes('application/json')) {
        data = await res.json();
      }

      if (res.ok && (!data || data.ok)) {
        alert('Vielen Dank für Ihre Nachricht! Wir werden uns bald bei Ihnen melden.');
        // Formular zurücksetzen
        setFormData({ 
            name: '', 
            email: '', 
            message: '', 
            hp: '', 
            privacyAccepted: false 
        });
      } else {
        const errMsg = data?.error || 'Senden fehlgeschlagen. Bitte später erneut versuchen.';
        alert(errMsg);
      }
    } catch (err) {
      alert('Netzwerkfehler. Bitte später erneut versuchen.');
    } finally {
      setSubmitting(false);
    }
  };

  // Social Media URLs
  const facebookUrl = "#";
  const instagramUrl = "https://www.instagram.com/jsplottdesign/";

  return (
    <section id="contact" className="section contact-section">
      <div className="container">
        <h2>Kontakt</h2>
        <div className="contact-content">
          
          {/* Linke Seite: Infos */}
          <div className="contact-info">
            <h3>Kontaktinformation</h3>
            <p>
              <strong>Adresse:</strong><br />
              Eibenweg 13<br />
              36251 Bad Hersfeld
            </p>
            <p>
              <strong>Email:</strong><br />
              <a href="mailto:info@JSPlottDesign.de">info@JSPlottDesign.de</a>
            </p>
            <p>
              <strong>Telefon:</strong><br />
              Mobil: <a href="tel:+491717924528">+49 171 7924528</a>
            </p>

            <div className="social-media">
              <h3>Soziale Medien</h3>
              <div className="social-icons-container">
                <a
                  href={instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="JS-Plott-Design auf Instagram"
                >
                  <InstagramIcon className="social-icon" />
                </a>
                {facebookUrl !== '#' && (
                  <a
                    href={facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="JS-Plott-Design auf Facebook"
                  >
                    <FacebookIcon className="social-icon" />
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Rechte Seite: Formular */}
          <div className="contact-form">
            <h3>Kontaktformular</h3>
            <form onSubmit={handleSubmit} noValidate>
              
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={submitting}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={submitting}
                />
              </div>

              {/* Honeypot (versteckt) */}
              <div className="form-group" style={{ display: 'none' }}>
                <label htmlFor="hp">HP</label>
                <input
                  type="text"
                  id="hp"
                  name="hp"
                  value={formData.hp}
                  onChange={handleChange}
                  autoComplete="off"
                  tabIndex={-1}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Nachricht</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  disabled={submitting}
                ></textarea>
              </div>

              {/* NEU: Datenschutz Checkbox */}
              <div className="form-group checkbox-wrapper" style={{ marginTop: '10px', marginBottom: '20px' }}>
                <label style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', fontSize: '0.9rem' }}>
                  <input
                    type="checkbox"
                    name="privacyAccepted"
                    checked={formData.privacyAccepted}
                    onChange={handleChange}
                    style={{ width: 'auto', marginTop: '4px' }}
                    disabled={submitting}
                  />
                  <span>
                    Ich habe die <a href="/rechtliches" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a> zur Kenntnis genommen. Ich stimme zu, dass meine Angaben zur Kontaktaufnahme und für Rückfragen dauerhaft gespeichert werden.
                  </span>
                </label>
              </div>

              <button type="submit" className="submit-button" disabled={submitting}>
                {submitting ? 'Senden…' : 'Nachricht senden'}
              </button>

            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;